import { editorContentShiftViewState } from "../..";
import { mutatorAction } from "satcheljs";

export default mutatorAction("setIsActivitiesDialogOpen", function setIsActivitiesDialogOpen(isOpen: boolean) {
        editorContentShiftViewState().isActivitiesDialogOpen = isOpen;
});